import CheckMarkIcon from '@mui/icons-material/Check'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { useEffect, useState } from 'react'
import { colors } from 'styles/theme'
import clipboard from 'utils/clipboard'
import { SxProps, Theme } from '@mui/material'

interface Props {
  value: any
  sx?: SxProps<Theme>
}

export default function CopyToClipboard({ value, sx }: Props) {
  const [showCheckMark, setShowCheckMark] = useState<boolean>(false)

  useEffect(() => {
    let id = null
    if (showCheckMark) {
      id = setTimeout(() => setShowCheckMark(false), 2000)
    }
    return () => clearTimeout(id)
  }, [showCheckMark])

  if (!clipboard.supported) return null

  return (
    <IconButton
      data-testid="copy-button"
      size="small"
      onClick={(e) => {
        e.stopPropagation()
        clipboard.copyText(value.toString())
        setShowCheckMark(true)
      }}
    >
      {showCheckMark ? (
        <Tooltip title="Copied" arrow>
          <CheckMarkIcon
            sx={{ width: 12, height: 12, color: colors.green[500], ...sx }}
          />
        </Tooltip>
      ) : (
        <ContentCopyIcon sx={{ width: 12, height: 12, ...sx }} />
      )}
    </IconButton>
  )
}
